import { t } from 'i18next'
import { getStartNode, openCustomInputDialog } from './customInputHelpers'

const PX_TO_PT = 0.75

const getCurrentFontSize = (editor: Editor): string => {
  const node = getStartNode(editor)
  const fontSize = editor.dom.getStyle(node, 'font-size')

  if (fontSize) return fontSize

  const computed = window.getComputedStyle(node).fontSize
  if (computed?.endsWith('px')) {
    const px = parseFloat(computed)
    if (!isNaN(px)) {
      const pt = Math.round(px * PX_TO_PT * 100) / 100
      return `${pt}pt`
    }
  }

  return computed || ''
}

export const registerCustomFontSizePlugin = ({
  editor,
}: {
  editor: Editor
}) => {
  editor.ui.registry.addButton('customFontSize', {
    icon: 'kebab',
    tooltip: t('editor.tinyMCE.customFontSize.tooltip'),
    onAction: () => {
      const currentFontSize = getCurrentFontSize(editor)

      openCustomInputDialog({
        editor,
        translationKey: 'customFontSize',
        inputName: 'fontSize',
        placeholder: '12',
        initialValue: currentFontSize.replace('pt', '').replace('px', ''),
        validation: {
          maxIntegers: 4,
          maxDecimals: 2,
          min: 0.01,
          max: 9999.99,
        },
        onValidSubmit: (value) => {
          editor.execCommand('FontSize', false, `${value}pt`)
        },
      })
    },
  })
}
